module.exports = __webpack_public_path__ + "img/new_logo.2a098a9e.svg";